import React from 'react';
import Grid from '@mui/material/Grid2';

import { 
  TransformUpgradeFeature,
} from "@dndModels";

import SelectObjectBox from "@components/input/selects/SelectObjectBoxSimple";

interface Props { 
  obj: TransformUpgradeFeature;
  disabled: boolean;
  change_time: number;
  height: number;
  onChange: (changed: TransformUpgradeFeature) => void; 
}

export default function TransformUpgradeFeatureInput({
  obj,
  disabled,
  change_time,
  height,
  onChange,
}: Props) {

  return (
    <Grid container spacing={0} direction="row">
      <Grid
        size={{
          xs: 12
        }}>
        <SelectObjectBox
          name="Adaptation"
          data_type="adaptation"
          value={obj.adaptation_id}
          disabled={disabled}
          onChange={(changed: string) => {
            const new_obj = obj;
            new_obj.adaptation_id = changed;
            onChange(new_obj);
          }}
        />
      </Grid>
    </Grid>
  ); 
}